


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/infrastructure/api/movement/movementApi';
import download from '@/infrastructure/api/download';
import moment from 'moment';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import { progress } from '@/script/progress';
import {移動修正移動先型} from '@/type/movement/records/modify/部署間移動修正削除';
import {移動入力在庫場所結果型} from '@/type/movement/records/register/部署間移動入力';
import 部署間移動履歴検索条件入力チェッカー from '@/type/movement/records/history/部署間移動履歴検索条件入力チェッカー';
import {移動履歴型, 移動履歴検索依頼型, 移動履歴検索結果型} from '@/type/movement/records/history/部署間移動履歴';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    ConfirmDialog,
    AlertDialog,
    SenderSelector,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    数値フォーマット(value: number): string {
      if (!value) {
        return '';
      }
      return value.toFixed(3);
    },
  },
})
export default class ReferenceMovement extends Vue {
  アラートメッセージ: string[] = [];

  在庫場所一覧: 移動修正移動先型[] = [];

  移動履歴一覧: 移動履歴型[] = [];
  選択移動履歴: 移動履歴型 | null = null;

  移動履歴検索依頼初期値: 移動履歴検索依頼型 = {
    メーカー名検索文字列: '',
    商品名カナ検索文字列: '',
    移動年月日検索開始日: moment().startOf('month').toDate(),
    移動年月日検索終了日: null,
    検索対象商品区分: null,
    在庫場所部署コード: this.ログインユーザの部署コード,
    移動先部署コード: null,
    移動入力方法区分: null,
    登録者: this.管理者である ? null : this.ログインユーザの利用者コード,
    検索対象データ作成区分: null,
  };

  移動履歴検索依頼: 移動履歴検索依頼型 = {...this.移動履歴検索依頼初期値};

  async mounted(): Promise<void> {
    await this.在庫場所一覧取得();
  }

  // computed
  get ログインユーザの部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get ログインユーザの利用者コード(): string {
    return loginModule.利用者コードを取得する;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 渓仁会仕様である(): boolean {
    return loginModule.渓仁会仕様である;
  }

  get 外部連携を利用する(): boolean {
    return loginModule.外部連携を利用する;
  }

  async 在庫場所一覧取得(): Promise<void> {
    this.アラートメッセージ = [];
    await api.移動入力在庫場所一覧を取得する()
      .then((response: 移動入力在庫場所結果型) => {
        this.在庫場所一覧 = response.移動在庫場所結果一覧;
      })
      .catch((error: any) => {
        this.在庫場所一覧 = [];
        this.アラートメッセージ.push(error.data.message);
        this.ダイアログを開く('アラート');
      });
  }

  async 移動履歴一覧取得(): Promise<void> {
    const checker = new 部署間移動履歴検索条件入力チェッカー(this.移動履歴検索依頼);
    if (checker.hasErrors()) {
      this.アラートメッセージ = checker.errorMessages();
      this.ダイアログを開く('アラート');
      return;
    }

    this.移動履歴一覧 = [];
    this.選択移動履歴 = null;

    await api.移動履歴一覧を取得する(this.移動履歴検索依頼)
      .then((response: 移動履歴検索結果型) => {
        this.移動履歴一覧 = response.移動履歴一覧;
        if (this.移動履歴一覧.length === 0) {
          this.アラートメッセージ = ['該当の移動は存在しませんでした。'];
          this.ダイアログを開く('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = [response.アラートメッセージ];
          this.ダイアログを開く('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.ダイアログを開く('アラート');
      });
  }

  検索条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.検索条件入力エラー判定(項目名)};
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 部署間移動履歴検索条件入力チェッカー(this.移動履歴検索依頼);
    return checker.hasError(項目名);
  }

  リストから選択する(選択移動履歴: 移動履歴型) {
    this.選択移動履歴 = 選択移動履歴;
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    const checker = new 部署間移動履歴検索条件入力チェッカー(this.移動履歴検索依頼);
    if (checker.hasErrors()) {
      this.アラートメッセージ = checker.errorMessages();
      this.ダイアログを開く('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  async 出力するハンドラ(): Promise<void> {
    this.ダイアログを閉じる('出力ダイアログ');
    await progress(this.excelout);
  }

  async excelout(): Promise<void> {
    await download.移動履歴一覧表を出力する('移動履歴一覧.xlsx', this.移動履歴検索依頼);
  }

  クリア(): void {
    this.移動履歴一覧 = [];
    this.選択移動履歴 = null;
    this.移動履歴検索依頼 = {...this.移動履歴検索依頼初期値};
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }
}
